import PargodaModal from '../PargodaModal';
import { jobsActions, jobsSelectors } from '../../actions';
import {
    PargodaRoundButton,
    RootState,
    Typography,
    useAppDispatch,
    useAppSelector,
    useTheme,
} from '../../base';
import { ButtonsContainer } from './ConfirmJobCloseOrCancelModal.style';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../common';

interface Props {
    isModalOpen: boolean;
}

const ConfirmJobCloseOrCancelModal = (props: Props) => {
    const { isModalOpen } = props;
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const { t } = useTranslation();
    const closeModal = (value: boolean) => {
        dispatch(jobsActions.setConfirmJobCloseOrCancelModalOpen(value));
    };
    const cancelOrCloseJob = useAppSelector((state: RootState) =>
        jobsSelectors.getCancelOrCloseJob(state)
    );

    const onClickProceed = () => {
        if (cancelOrCloseJob) {
            dispatch(jobsActions.updateJobStatus(cancelOrCloseJob));
            closeModal(false);
        }
    };

    return (
        <PargodaModal
            isModalOpen={isModalOpen}
            setIsModalOpen={(value: boolean) => {
                closeModal(value);
            }}
            modalTitle={t('jobsPage.confirmCancelOrCompleteJobTitle')}
        >
            <Typography variant="body2" pt={2} pb={2}>
                {t('jobsPage.confirmCancelOrCompleteJobDescription', {
                    status: capitalizeFirstLetter(cancelOrCloseJob?.status),
                })}
            </Typography>
            <ButtonsContainer>
                <PargodaRoundButton
                    textColor={theme.palette.grey[600]}
                    variant={'outlined'}
                    loadingPosition={'start'}
                    onClick={() => {
                        closeModal(false);
                    }}
                    startIcon={<></>}
                    loading={false}
                    sx={{
                        marginInlineEnd: theme.spacing(1.5),
                        height: '48px',
                        width: '214px',
                        fontWeight: 600,
                        fontSize: '16px',
                    }}
                >
                    {t('jobsPage.confirmCancelOrCompleteJobCancel')}
                </PargodaRoundButton>
                <PargodaRoundButton
                    onClick={onClickProceed}
                    type="submit"
                    variant="contained"
                    loading={false}
                    disabled={false}
                    sx={{
                        background: `linear-gradient(0deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        color: theme.palette.common.white,
                        width: '220px',
                        height: '48px',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        textTransform: 'none',
                    }}
                >
                    {t('jobsPage.confirmCancelOrCompleteJobConfirm')}
                </PargodaRoundButton>
            </ButtonsContainer>
        </PargodaModal>
    );
};

export default ConfirmJobCloseOrCancelModal;
